import { VisaDocumentModel } from 'api-hooks/visa-document';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';

export const VisaDocumentFlightItemFormSchema = () =>
  Yup.object({
    id: Yup.string(),
    airlineId: Yup.string().default(''),
    preferenceId: Yup.string().default(''),
    route: Yup.string().default(''),
    // additional information
    customId: Yup.string(),
  });

export const VisaDocumentFlightFormSchema = () =>
  Yup.object({
    id: Yup.string(),
    name: Yup.string().default(''),
    description: Yup.string().default(''),
    items: Yup.array(VisaDocumentFlightItemFormSchema()).default([]),
  });

export const VisaDocumentHotelItemFormSchema = () =>
  Yup.object({
    id: Yup.string(),
    hotelRoomId: Yup.string().default(''),
    cityTax: Yup.string().default(''),
    description: Yup.string().default(''),
    // additional information
    customId: Yup.string(),
  });

export const VisaDocumentHotelFormSchema = () =>
  Yup.object({
    id: Yup.string(),
    hotelId: Yup.string().default(''),
    remark: Yup.string().default(''),
    items: Yup.array(VisaDocumentHotelItemFormSchema()).default([]),
  });

export const VisaDocumentFormSchema = () =>
  Yup.object({
    name: Yup.string().default(''),
    code: Yup.string().default(''),
    description: Yup.string().default(''),
    transactionAt: Yup.date().default(new Date()),
    price: Yup.number().default(0),
    visaDocumentFlights: Yup.array(VisaDocumentFlightFormSchema()).default([]),
    visaDocumentHotels: Yup.array(VisaDocumentHotelFormSchema()).default([]),
  });

export type VisaDocumentFormType = Yup.InferType<
  ReturnType<typeof VisaDocumentFormSchema>
> & {
  visaDocument?: VisaDocumentModel;
};

export type VisaDocumentMethodType = ReturnType<
  typeof useForm<VisaDocumentFormType>
>;

export type VisaDocumentFlightFormType = Yup.InferType<
  ReturnType<typeof VisaDocumentFlightFormSchema>
>;

export type VisaDocumentFlightItemFormType = Yup.InferType<
  ReturnType<typeof VisaDocumentFlightItemFormSchema>
>;

export type VisaDocumentHotelFormType = Yup.InferType<
  ReturnType<typeof VisaDocumentHotelFormSchema>
>;

export type VisaDocumentHotelItemFormType = Yup.InferType<
  ReturnType<typeof VisaDocumentHotelItemFormSchema>
>;
